import React, { useEffect, useState } from 'react';

/* ─── Styles ────────────────────────────────────────────────── */
const styles = `

  /* NAV */
  .nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    padding: 1.5rem 3rem;
    display: flex; justify-content: space-between; align-items: center;
    transition: background 0.5s, backdrop-filter 0.5s;
  }
  .nav.scrolled {
    background: rgba(10,22,40,0.92);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(74,144,184,0.1);
  }
  .nav-logo {
    display: flex; flex-direction: column; line-height: 1;
    text-decoration: none;
  }
  .nav-logo-main {
    font-family: var(--font-display); font-size: 1.5rem;
    font-weight: 500; color: var(--white); letter-spacing: 0.02em;
  }
  .nav-logo-sub {
    font-size: 0.65rem; letter-spacing: 0.25em; text-transform: uppercase;
    color: var(--dawn); font-weight: 400; margin-top: 2px;
  }
  .nav-links { display: flex; gap: 2.5rem; list-style: none; }
  .nav-links a {
    font-size: 0.78rem; letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--mist); text-decoration: none; font-weight: 400;
    transition: color 0.2s;
  }
  .nav-links a:hover { color: var(--dawn); }

  /* HERO */
  .hero {
    min-height: 100vh; position: relative;
    display: flex; align-items: center;
    overflow: hidden;
  }
  .hero-sky {
    position: absolute; inset: 0; z-index: 0;
    background:
      radial-gradient(ellipse 120% 60% at 50% 100%, rgba(30,77,107,0.9) 0%, transparent 60%),
      radial-gradient(ellipse 80% 40% at 50% 90%, rgba(212,133,106,0.15) 0%, transparent 50%),
      radial-gradient(ellipse 60% 30% at 50% 95%, rgba(232,201,126,0.1) 0%, transparent 40%),
      linear-gradient(to bottom, #0a1628 0%, #0d2540 40%, #1a3a5c 75%, #1e4d6b 100%);
  }
  .hero-stars {
    position: absolute; inset: 0; z-index: 1;
    background-image:
      radial-gradient(1px 1px at 20% 15%, rgba(255,255,255,0.6) 0%, transparent 100%),
      radial-gradient(1px 1px at 45% 8%, rgba(255,255,255,0.4) 0%, transparent 100%),
      radial-gradient(1px 1px at 70% 20%, rgba(255,255,255,0.5) 0%, transparent 100%),
      radial-gradient(1px 1px at 85% 10%, rgba(255,255,255,0.3) 0%, transparent 100%),
      radial-gradient(1px 1px at 10% 35%, rgba(255,255,255,0.4) 0%, transparent 100%),
      radial-gradient(1px 1px at 55% 25%, rgba(255,255,255,0.3) 0%, transparent 100%),
      radial-gradient(2px 2px at 30% 5%, rgba(255,255,255,0.7) 0%, transparent 100%),
      radial-gradient(1px 1px at 90% 30%, rgba(255,255,255,0.4) 0%, transparent 100%),
      radial-gradient(1px 1px at 15% 55%, rgba(255,255,255,0.2) 0%, transparent 100%),
      radial-gradient(2px 2px at 75% 12%, rgba(232,201,126,0.6) 0%, transparent 100%);
  }
  .horizon-line {
    position: absolute; bottom: 28%; left: 0; right: 0; z-index: 2;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(232,201,126,0.3), rgba(74,144,184,0.4), rgba(232,201,126,0.3), transparent);
  }
  .hero-glow {
    position: absolute; bottom: 20%; left: 50%; transform: translateX(-50%);
    width: 600px; height: 200px; z-index: 2;
    background: radial-gradient(ellipse at center, rgba(232,201,126,0.12) 0%, rgba(212,133,106,0.06) 40%, transparent 70%);
    filter: blur(20px);
  }
  .hero-content {
    position: relative; z-index: 3;
    padding: 0 3rem; max-width: 800px; margin: 0 auto;
    text-align: center; width: 100%;
    padding-top: 6rem;
  }
  .hero-eyebrow {
    font-size: 0.72rem; letter-spacing: 0.35em; text-transform: uppercase;
    color: var(--dawn); margin-bottom: 1.5rem; display: block;
    opacity: 0; animation: fadeDown 0.8s ease forwards 0.3s;
  }
  .hero-headline {
    font-family: var(--font-display);
    font-size: clamp(3rem, 7vw, 6rem);
    font-weight: 400; line-height: 1.1;
    color: var(--white); margin-bottom: 1rem;
    opacity: 0; animation: fadeDown 1s ease forwards 0.5s;
  }
  .hero-headline em { font-style: italic; color: var(--dawn); }
  .hero-tagline {
    font-family: var(--font-display); font-style: italic;
    font-size: clamp(1.1rem, 2.5vw, 1.6rem); font-weight: 400;
    color: var(--mist); margin-bottom: 3rem; line-height: 1.5;
    opacity: 0; animation: fadeDown 1s ease forwards 0.7s;
  }
  .hero-ctas {
    display: flex; gap: 1rem; justify-content: center; flex-wrap: wrap;
    opacity: 0; animation: fadeDown 1s ease forwards 0.9s;
  }
  .btn-primary {
    padding: 0.9rem 2.5rem;
    background: linear-gradient(135deg, var(--dawn), var(--rose));
    color: var(--deep); font-family: var(--font-body);
    font-size: 0.78rem; font-weight: 500; letter-spacing: 0.15em;
    text-transform: uppercase; text-decoration: none; border: none;
    cursor: pointer; transition: all 0.3s; display: inline-block;
  }
  .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 8px 30px rgba(232,201,126,0.3); }
  .btn-outline {
    padding: 0.9rem 2.5rem;
    background: transparent;
    border: 1px solid rgba(74,144,184,0.4);
    color: var(--mist); font-family: var(--font-body);
    font-size: 0.78rem; font-weight: 400; letter-spacing: 0.15em;
    text-transform: uppercase; text-decoration: none; cursor: pointer;
    transition: all 0.3s; display: inline-block;
  }
  .btn-outline:hover { border-color: var(--sky); color: var(--white); }
  .hero-scroll-hint {
    position: absolute; bottom: 2rem; left: 50%; transform: translateX(-50%);
    z-index: 3; text-align: center;
    opacity: 0; animation: fadeIn 1s ease forwards 1.5s;
  }
  .hero-scroll-hint span { font-size: 0.65rem; letter-spacing: 0.2em; text-transform: uppercase; color: var(--muted); display: block; margin-bottom: 0.5rem; }
  .scroll-chevron { width: 20px; height: 20px; border-right: 1px solid var(--muted); border-bottom: 1px solid var(--muted); transform: rotate(45deg); margin: 0 auto; animation: bounce 2s ease infinite; }

  /* BELIEF */
  .belief {
    padding: 8rem 3rem;
    background: var(--navy);
    position: relative; overflow: hidden;
  }
  .belief::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(74,144,184,0.3), transparent);
  }
  .belief-inner { max-width: 750px; margin: 0 auto; text-align: center; }
  .section-label {
    font-size: 0.7rem; letter-spacing: 0.35em; text-transform: uppercase;
    color: var(--dawn); display: block; margin-bottom: 2rem;
  }
  .dawn-divider {
    width: 50px; height: 1px;
    background: linear-gradient(to right, var(--rose), var(--dawn));
    margin: 0 auto 2.5rem;
  }
  .belief-quote {
    font-family: var(--font-display); font-size: clamp(1.6rem, 3.5vw, 2.6rem);
    font-weight: 400; line-height: 1.35; color: var(--white);
    margin-bottom: 2rem;
  }
  .belief-quote em { font-style: italic; color: var(--dawn); }
  .belief-body { font-size: 0.95rem; color: var(--muted); line-height: 1.9; max-width: 580px; margin: 0 auto; }

  /* TIMELINE */
  .timeline-section {
    padding: 8rem 3rem;
    background: var(--deep);
    position: relative;
  }
  .timeline-section::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(74,144,184,0.2), transparent);
  }
  .timeline-header { text-align: center; margin-bottom: 5rem; }
  .section-title {
    font-family: var(--font-display); font-size: clamp(2rem, 4vw, 3rem);
    font-weight: 400; color: var(--white); margin-bottom: 1rem; line-height: 1.2;
  }
  .section-title em { font-style: italic; color: var(--dawn); }
  .section-sub { font-size: 0.92rem; color: var(--muted); max-width: 500px; margin: 0 auto; line-height: 1.8; }
  .timeline {
    max-width: 900px; margin: 0 auto;
    position: relative;
  }
  .timeline::before {
    content: ''; position: absolute; left: 50%; top: 0; bottom: 0;
    width: 1px; transform: translateX(-50%);
    background: linear-gradient(to bottom, transparent, rgba(74,144,184,0.3) 10%, rgba(74,144,184,0.3) 90%, transparent);
  }
  .timeline-item {
    display: flex; margin-bottom: 3rem; position: relative;
    align-items: flex-start;
  }
  .timeline-item:nth-child(odd) { flex-direction: row; }
  .timeline-item:nth-child(even) { flex-direction: row-reverse; }
  .timeline-content {
    width: calc(50% - 2.5rem);
    padding: 1.8rem 2rem;
    background: rgba(22,40,64,0.6);
    border: 1px solid rgba(74,144,184,0.12);
    backdrop-filter: blur(8px);
    transition: border-color 0.3s, background 0.3s;
  }
  .timeline-content:hover {
    border-color: rgba(232,201,126,0.25);
    background: rgba(22,40,64,0.8);
  }
  .timeline-item:nth-child(odd) .timeline-content { margin-right: auto; }
  .timeline-item:nth-child(even) .timeline-content { margin-left: auto; }
  .timeline-dot {
    position: absolute; left: 50%; top: 1.8rem;
    transform: translateX(-50%);
    width: 14px; height: 14px; border-radius: 50%;
    background: var(--deep);
    border: 2px solid var(--dawn);
    z-index: 1;
    box-shadow: 0 0 12px rgba(232,201,126,0.3);
  }
  .milestone-icon { font-size: 1.4rem; margin-bottom: 0.6rem; display: block; }
  .milestone-title {
    font-family: var(--font-display); font-size: 1.15rem; font-weight: 500;
    color: var(--white); margin-bottom: 0.4rem;
  }
  .milestone-desc { font-size: 0.85rem; color: var(--muted); line-height: 1.7; }

  /* SERVICES */
  .services {
    padding: 8rem 3rem;
    background: var(--navy);
    position: relative;
  }
  .services::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(74,144,184,0.3), transparent);
  }
  .services-inner { max-width: 1100px; margin: 0 auto; }
  .services-grid {
    display: grid; grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem; margin-top: 4rem;
  }
  .service-card {
    padding: 2.5rem 2rem;
    background: rgba(10,22,40,0.5);
    border: 1px solid rgba(74,144,184,0.1);
    position: relative; overflow: hidden;
    transition: all 0.3s;
  }
  .service-card::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, var(--rose), var(--dawn));
    transform: scaleX(0); transform-origin: left;
    transition: transform 0.4s ease;
  }
  .service-card:hover { border-color: rgba(74,144,184,0.25); }
  .service-card:hover::before { transform: scaleX(1); }
  .service-card-icon {
    width: 44px; height: 44px; margin-bottom: 1.5rem;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(232,201,126,0.15), rgba(74,144,184,0.1));
    border: 1px solid rgba(232,201,126,0.2);
    display: flex; align-items: center; justify-content: center;
    font-size: 1.1rem;
  }
  .service-card-title {
    font-family: var(--font-display); font-size: 1.2rem; font-weight: 500;
    color: var(--white); margin-bottom: 0.75rem;
  }
  .service-card-desc { font-size: 0.85rem; color: var(--muted); line-height: 1.8; }

  /* TRANSITION */
  .transition-section {
    padding: 9rem 3rem;
    background: var(--deep);
    text-align: center; position: relative; overflow: hidden;
  }
  .transition-section::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(74,144,184,0.2), transparent);
  }
  .transition-bg {
    position: absolute; inset: 0;
    background:
      radial-gradient(ellipse 60% 50% at 50% 100%, rgba(30,77,107,0.4) 0%, transparent 60%),
      radial-gradient(ellipse 40% 30% at 50% 100%, rgba(232,201,126,0.06) 0%, transparent 50%);
  }
  .transition-inner { position: relative; z-index: 1; max-width: 700px; margin: 0 auto; }
  .transition-headline {
    font-family: var(--font-display); font-size: clamp(2.2rem, 5vw, 4rem);
    font-weight: 400; line-height: 1.15; color: var(--white); margin-bottom: 1.5rem;
  }
  .transition-headline em { font-style: italic; color: var(--dawn); }
  .transition-text { font-size: 1rem; color: var(--muted); line-height: 1.9; margin-bottom: 3rem; max-width: 560px; margin-left: auto; margin-right: auto; }

  /* FAITHS */
  .faiths {
    padding: 5rem 3rem;
    background: var(--mid);
    text-align: center;
  }
  .faiths-inner { max-width: 800px; margin: 0 auto; }
  .faiths-title {
    font-family: var(--font-display); font-size: 1.4rem; font-weight: 400;
    font-style: italic; color: var(--mist); margin-bottom: 2rem;
  }
  .faiths-list {
    display: flex; flex-wrap: wrap; gap: 1rem; justify-content: center;
    list-style: none;
  }
  .faiths-list li {
    padding: 0.4rem 1.2rem;
    border: 1px solid rgba(74,144,184,0.2);
    font-size: 0.78rem; letter-spacing: 0.1em; color: var(--muted);
    text-transform: uppercase;
  }

  /* CONTACT */
  .contact {
    padding: 8rem 3rem;
    background: var(--navy);
    position: relative;
  }
  .contact::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(74,144,184,0.3), transparent);
  }
  .contact-inner { max-width: 600px; margin: 0 auto; text-align: center; }
  .contact-form { margin-top: 3rem; display: flex; flex-direction: column; gap: 1rem; text-align: left; }
  .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
  .form-label { font-size: 0.7rem; letter-spacing: 0.15em; text-transform: uppercase; color: var(--muted); display: block; margin-bottom: 0.4rem; }
  .form-field {
    width: 100%; padding: 0.85rem 1.1rem;
    background: rgba(10,22,40,0.6);
    border: 1px solid rgba(74,144,184,0.15);
    color: var(--light); font-family: var(--font-body); font-size: 0.875rem;
    font-weight: 300; outline: none; transition: border-color 0.3s;
  }
  .form-field:focus { border-color: rgba(232,201,126,0.4); }
  .form-field::placeholder { color: rgba(122,154,176,0.5); }
  textarea.form-field { resize: vertical; min-height: 130px; }
  .form-submit {
    padding: 1rem; width: 100%; margin-top: 0.5rem;
    background: linear-gradient(135deg, var(--dawn), var(--rose));
    border: none; color: var(--deep);
    font-family: var(--font-body); font-size: 0.8rem;
    font-weight: 500; letter-spacing: 0.18em; text-transform: uppercase;
    cursor: pointer; transition: all 0.3s;
  }
  .form-submit:hover { opacity: 0.9; transform: translateY(-1px); box-shadow: 0 6px 25px rgba(232,201,126,0.25); }
  .thankyou {
    margin-top: 3rem; padding: 3rem 2rem;
    border: 1px solid rgba(232,201,126,0.2);
    text-align: center;
  }
  .thankyou-title { font-family: var(--font-display); font-size: 1.8rem; font-style: italic; color: var(--dawn); margin-bottom: 0.75rem; }
  .thankyou-text { font-size: 0.9rem; color: var(--muted); }

  /* FOOTER */
  .footer {
    padding: 2.5rem 3rem;
    background: var(--deep);
    border-top: 1px solid rgba(74,144,184,0.1);
    display: flex; justify-content: space-between; align-items: center;
  }
  .footer-logo { font-family: var(--font-display); font-size: 1.1rem; color: var(--white); text-decoration: none; }
  .footer-logo span { color: var(--dawn); font-style: italic; }
  .footer-copy { font-size: 0.75rem; color: var(--muted); }

  /* ANIMATIONS */
  @keyframes fadeDown {
    from { opacity: 0; transform: translateY(-16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes bounce {
    0%, 100% { transform: rotate(45deg) translateY(0); }
    50%       { transform: rotate(45deg) translateY(6px); }
  }

  /* REVEAL */
  .reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.9s ease, transform 0.9s ease; }
  .reveal.visible { opacity: 1; transform: translateY(0); }

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .services-grid { grid-template-columns: 1fr 1fr; }
    .timeline::before { left: 20px; }
    .timeline-item, .timeline-item:nth-child(even) { flex-direction: column; }
    .timeline-content, .timeline-item:nth-child(odd) .timeline-content,
    .timeline-item:nth-child(even) .timeline-content { width: 100%; margin-left: 3.5rem; }
    .timeline-dot { left: 20px; }
  }
  @media (max-width: 640px) {
    .nav { padding: 1.2rem 1.5rem; }
    .nav-links { display: none; }
    .hero-content, .belief, .timeline-section, .services, .transition-section, .faiths, .contact { padding-left: 1.5rem; padding-right: 1.5rem; }
    .services-grid { grid-template-columns: 1fr; }
    .form-row { grid-template-columns: 1fr; }
    .footer { flex-direction: column; gap: 1rem; text-align: center; }
  }
`;

/* ─── Data ──────────────────────────────────────────────────── */
const milestones = [
  { icon: '✦', title: 'The First Breath', desc: 'Where the journey begins. Birth, arrival, and the wonder of a new life entering the world.' },
  { icon: '👣', title: 'First Steps', desc: 'The toddler years — learning to walk, to talk, to explore. Every stumble and triumph remembered.' },
  { icon: '🎒', title: 'First Day of School', desc: 'The uniform, the nerves, the excitement. The beginning of a world outside the front door.' },
  { icon: '💫', title: 'Growing Up', desc: 'Friendships, firsts, discoveries — the defining moments of youth that shaped who they became.' },
  { icon: '❤️', title: 'First Love', desc: 'The butterflies, the letters, the memories. The people who touched their heart along the way.' },
  { icon: '💍', title: 'Marriage & Partnership', desc: 'The moment they chose someone, and someone chose them. A bond that defined their story.' },
  { icon: '👨‍👩‍👧', title: 'Family', desc: 'Children, grandchildren, the family they built and the love they multiplied into the world.' },
  { icon: '🌅', title: 'Their Legacy', desc: 'Whatever you believe happens next — we honour the extraordinary journey of the life that was lived, and the love they leave behind in all they touched.' },
];

const services = [
  { icon: '📖', title: 'Life Timeline Creation', desc: 'We work with your family to map every key milestone — gathering stories, photos, and memories into a beautiful chronological tribute.' },
  { icon: '🎬', title: 'Tribute Film', desc: 'A cinematic journey through their life, set to music they loved, telling their story from first breath to new horizon.' },
  { icon: '✦', title: 'Milestone Display', desc: 'A physical or digital installation at the celebration, bringing their timeline to life for all who attend.' },
  { icon: '🎵', title: 'Soundtrack of Their Life', desc: 'Music curated to mark each chapter — the songs that were playing when life\'s greatest moments happened.' },
  { icon: '💌', title: 'Memory Collection', desc: 'We gather tributes, stories and messages from family and friends near and far before the celebration.' },
  { icon: '🌿', title: 'Full Event Planning', desc: 'Venue, catering, logistics and day-of coordination — everything handled so your family can simply be present.' },
];

/* ─── App ───────────────────────────────────────────────────── */
export default function App() {
  const [scrolled, setScrolled] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', lovedOne: '', message: '' });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.1 });
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const handleSubmit = (e) => { e.preventDefault(); setSubmitted(true); };
  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  return (
    <>
      <style>{styles}</style>

      {/* NAV */}
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
        <a href="#hero" className="nav-logo">
          <span className="nav-logo-main">New Horizon</span>
          <span className="nav-logo-sub">Life Celebrations</span>
        </a>
        <ul className="nav-links">
          <li><a href="#belief">Our Belief</a></li>
          <li><a href="#timeline">The Journey</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#contact">Begin</a></li>
        </ul>
      </nav>

      {/* HERO */}
      <section className="hero" id="hero">
        <div className="hero-sky" />
        <div className="hero-stars" />
        <div className="horizon-line" />
        <div className="hero-glow" />
        <div className="hero-content">
          <span className="hero-eyebrow">A celebration of a life beautifully lived</span>
          <h1 className="hero-headline">
            Every life is a<br /><em>remarkable journey.</em>
          </h1>
          <p className="hero-tagline">
            We honour each milestone — from first breath to their lasting legacy —<br />
            celebrating the soul of the person you loved.
          </p>
          <div className="hero-ctas">
            <a href="#contact" className="btn-primary">Begin a Tribute</a>
            <a href="#timeline" className="btn-outline">See How It Works</a>
          </div>
        </div>
        <div className="hero-scroll-hint">
          <span>Discover</span>
          <div className="scroll-chevron" />
        </div>
      </section>

      {/* BELIEF */}
      <section className="belief" id="belief">
        <div className="belief-inner">
          <span className="section-label reveal">Our Belief</span>
          <div className="dawn-divider reveal" />
          <p className="belief-quote reveal">
            "A life is not an ending —<br />it is a <em>remarkable journey.</em>"
          </p>
          <p className="belief-body reveal">
            Whatever your faith, whatever your belief — we all share the sense that
            the people we love deserve to be remembered in full. Their stories told.
            Their milestones honoured. Their love felt by everyone in the room.
            New Horizon exists to celebrate that journey — every chapter,
            every milestone, every beautiful moment of a life beautifully lived.
          </p>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="timeline-section" id="timeline">
        <div className="timeline-header reveal">
          <span className="section-label">The Journey</span>
          <h2 className="section-title">A life told <em>milestone by milestone</em></h2>
          <p className="section-sub">We map the key moments that defined them — creating a tribute as unique and layered as the person themselves.</p>
        </div>
        <div className="timeline">
          {milestones.map((m, i) => (
            <div className="timeline-item reveal" key={i} style={{ transitionDelay: `${i * 0.08}s` }}>
              <div className="timeline-content">
                <span className="milestone-icon">{m.icon}</span>
                <h3 className="milestone-title">{m.title}</h3>
                <p className="milestone-desc">{m.desc}</p>
              </div>
              <div className="timeline-dot" />
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES */}
      <section className="services" id="services">
        <div className="services-inner">
          <div className="timeline-header reveal">
            <span className="section-label">What We Do</span>
            <h2 className="section-title">Everything <em>beautifully handled</em></h2>
            <p className="section-sub">So your family can focus on being together, not on the details.</p>
          </div>
          <div className="services-grid">
            {services.map((s, i) => (
              <div className="service-card reveal" key={i} style={{ transitionDelay: `${i * 0.1}s` }}>
                <div className="service-card-icon">{s.icon}</div>
                <h3 className="service-card-title">{s.title}</h3>
                <p className="service-card-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TRANSITION */}
      <section className="transition-section">
        <div className="transition-bg" />
        <div className="transition-inner">
          <span className="section-label reveal">Our Promise</span>
          <h2 className="transition-headline reveal">
            Not an ending —<br /><em>a transition.</em>
          </h2>
          <p className="transition-text reveal">
            Whatever you believe happens next, we honour the extraordinary journey
            of the life that was lived. We create celebrations full of gratitude,
            full of love, and full of the person you came to honour — their story,
            their spirit, and the love they leave behind in all they touched.
          </p>
          <a href="#contact" className="btn-primary reveal">Start the Conversation</a>
        </div>
      </section>

      {/* FAITHS */}
      <section className="faiths">
        <div className="faiths-inner">
          <p className="faiths-title reveal">"Welcoming families of all faiths, beliefs and backgrounds."</p>
          <ul className="faiths-list reveal">
            {['Christian', 'Muslim', 'Jewish', 'Hindu', 'Buddhist', 'Sikh', 'Humanist', 'Non-religious', 'All faiths welcome'].map(f => (
              <li key={f}>{f}</li>
            ))}
          </ul>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact" id="contact">
        <div className="contact-inner">
          <span className="section-label reveal">Begin</span>
          <h2 className="section-title reveal">Tell us about <em>their journey</em></h2>
          <p className="section-sub reveal" style={{ margin: '1rem auto 0' }}>
            Every tribute begins with a conversation. Share a little about your loved one and we'll be in touch to start creating something worthy of their life.
          </p>
          {submitted ? (
            <div className="thankyou reveal visible">
              <p className="thankyou-title">Thank you.</p>
              <p className="thankyou-text">We'll be in touch soon to begin honouring their journey together.</p>
            </div>
          ) : (
            <form className="contact-form reveal" onSubmit={handleSubmit}>
              <div className="form-row">
                <div>
                  <label className="form-label">Your name</label>
                  <input className="form-field" placeholder="Your name" value={form.name} onChange={update('name')} required />
                </div>
                <div>
                  <label className="form-label">Email address</label>
                  <input className="form-field" type="email" placeholder="your@email.com" value={form.email} onChange={update('email')} required />
                </div>
              </div>
              <div>
                <label className="form-label">Their name</label>
                <input className="form-field" placeholder="The name of your loved one" value={form.lovedOne} onChange={update('lovedOne')} />
              </div>
              <div>
                <label className="form-label">Tell us about them</label>
                <textarea className="form-field" placeholder="Share a little about their life, their personality, what made them special…" value={form.message} onChange={update('message')} required />
              </div>
              <button type="submit" className="form-submit">Begin Their Tribute</button>
            </form>
          )}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <a href="#hero" className="footer-logo">New <span>Horizon</span></a>
        <p className="footer-copy">© {new Date().getFullYear()} New Horizon Life Celebrations. United Kingdom.</p>
      </footer>
    </>
  );
}
